import React from 'react';
import { useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import InvoiceDetailsPageActionButtons from '../components/InvoiceDetailsPageActionButtons';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import InvoiceForm from '../components/InvoiceForm';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import PeppolResponseStatusCard from '../../common/PeppolResponseStatusCard';
import { useGetInvoiceHandler } from '../dataHandlers/getInvoiceHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function InvoiceDetailsPage() {
  useDocumentTitle('Invoice Details');
  const { document_id } = useParams();
  const { invoice, isLoading } = useGetInvoiceHandler(document_id);

  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {invoice && (
        <TopBar title="Invoice Details" identifier={invoice?.document_id}>
          <InvoiceDetailsPageActionButtons data={invoice} />
        </TopBar>
      )}
      <IrbmStatusCard document={invoice} />
      <PeppolResponseStatusCard document={invoice} />

      <InvoiceForm onSubmit={() => {}} onCancel={() => {}} initialData={invoice} readOnly={true} />
    </Stack>
  );
}
